// extracted by mini-css-extract-plugin
module.exports = {"home-skeleton-warp":"home-skeleton-warp--2Z5dfOYu","home-skeleton-warp-normal":"home-skeleton-warp-normal--1KlEGNPz","home-skeleton-warp-base":"home-skeleton-warp-base--1OPxYocI"};